import { UIText3 } from '@cian/ui-kit';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';
import cx from 'clsx';
import * as React from 'react';

import { DynamicCalltrackingButton } from 'shared/components/DynamicCalltrackingButton';

import * as styles from './styles.css';

interface ICallButtonProps {
  announcementId: number;
  handleShowPhoneClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent> | MouseEvent) => void;
  isPhoneVisible: boolean;
  phone: string;
  siteBlockId: number | null;
  size?: TButtonSize;
  fill?: TButtonTheme;
  fullwidth?: boolean;
  agentName?: string | null;
}

export const CallButton = ({
  announcementId,
  handleShowPhoneClick,
  isPhoneVisible,
  phone,
  siteBlockId,
  agentName,
  size = 'M',
  fill = 'fill_secondary',
  fullwidth = false,
}: ICallButtonProps) => {
  return (
    <div
      className={cx(
        styles['container'],
        styles[`container-size-${size?.toLowerCase()}`],
        fullwidth && styles['container_fullwidth'],
      )}
    >
      <DynamicCalltrackingButton
        buttonText="Показать контакты"
        buttonFullWidth={fullwidth}
        isOpen={isPhoneVisible}
        announcementId={announcementId}
        onClick={handleShowPhoneClick}
        phone={phone}
        placeType="newbuildingDecorationsBanner"
        blockId={siteBlockId}
        buttonSize="XS"
        buttonTheme={fill}
      />

      {isPhoneVisible && agentName && (
        <UIText3 color="gray60_100" display="inline">
          {agentName}
        </UIText3>
      )}
    </div>
  );
};
